import { List, Stack } from '@mui/material';
import { FileTextIcon } from '@phosphor-icons/react/dist/ssr/FileText';
import { GearIcon } from '@phosphor-icons/react/dist/ssr/Gear';
import { HandHeartIcon } from '@phosphor-icons/react/dist/ssr/HandHeart';
import { LightbulbIcon } from '@phosphor-icons/react/dist/ssr/Lightbulb';
import { UsersIcon } from '@phosphor-icons/react/dist/ssr/Users';
import { vars } from '@tgtg/kit';
import { CharityVettingStatus } from 'api/users/types';
import useCurrentUserRoles from 'api/users/useCurrentUserRoles';
import useCharityVettingStatus from 'common/auth/useCharityVettingStatus';
import useNumberOfPendingDonations from 'features/donations/hooks/useNumberOfPendingDonations';
import { FormattedMessage } from 'react-intl';
import {
  DOCUMENTS_PATH,
  HELP_CENTER_PATH,
  DONATIONS_PATH,
  SETTINGS_PATH,
  USERS_PATH,
  VETTING_PROGRESS_PATH,
} from 'src/core/paths/paths';
import TGTGLogoIcon from 'ui/SvgIcon/icons/TGTGLogoIcon';

import msg from '../messages';

import DrawerNavItem from './DrawerNavItem';
import UserMenu from './UserMenu';

const navIconStyle = {
  width: vars.size.size300,
  height: vars.size.size300,
};

const BaseDrawer = () => {
  const numberOfDonationsToConfirm = useNumberOfPendingDonations();
  const { isCollector } = useCurrentUserRoles();
  const { charityVettingStatus } = useCharityVettingStatus();
  const isVetted = charityVettingStatus === CharityVettingStatus.Vetted;

  return (
    <Stack
      component='nav'
      direction='column'
      spacing={vars.spacing.neutral.small}
      sx={{
        minHeight: '100vh',
        width: 280,
        paddingX: vars.spacing.neutral.large,
        paddingY: vars.spacing.neutral.xxlarge,
        boxSizing: 'border-box',
      }}
    >
      <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <TGTGLogoIcon width={72} height={72} />
      </Stack>
      <Stack
        direction='column'
        spacing={vars.spacing.neutral.small}
        sx={{ justifyContent: 'space-between', flex: 1 }}
      >
        <List
          disablePadding
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: vars.spacing.neutral.small,
          }}
        >
          {isVetted ? (
            <>
              <DrawerNavItem
                to={DONATIONS_PATH}
                badgeContent={numberOfDonationsToConfirm}
                icon={<HandHeartIcon style={navIconStyle} />}
                label={<FormattedMessage {...msg.donations} />}
              />
              {!isCollector ? (
                <>
                  <DrawerNavItem
                    to={USERS_PATH}
                    icon={<UsersIcon style={navIconStyle} />}
                    label={<FormattedMessage {...msg.users} />}
                  />
                  <DrawerNavItem
                    to={DOCUMENTS_PATH}
                    icon={<FileTextIcon style={navIconStyle} />}
                    label={<FormattedMessage {...msg.documents} />}
                  />
                </>
              ) : null}
            </>
          ) : (
            <DrawerNavItem
              to={VETTING_PROGRESS_PATH}
              icon={<FileTextIcon style={navIconStyle} />}
              label={<FormattedMessage {...msg.yourApplication} />}
            />
          )}
          <DrawerNavItem
            to={HELP_CENTER_PATH}
            icon={<LightbulbIcon style={navIconStyle} />}
            label={<FormattedMessage {...msg.helpCenter} />}
          />
          <DrawerNavItem
            to={SETTINGS_PATH}
            icon={<GearIcon style={navIconStyle} />}
            label={<FormattedMessage {...msg.settings} />}
          />
        </List>
        <UserMenu />
      </Stack>
    </Stack>
  );
};

export default BaseDrawer;
